/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizers_TitleInputs */



/**
* | output |
* | --- |
* | "Organizers" |
*
* @param {Organizers_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const organizers_title = /** @type {((inputs?: Organizers_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizers_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Organisateurs")
	if (locale === "es") return /** @type {LocalizedString} */ ("Organizadores")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Organizadores")
	if (locale === "it") return /** @type {LocalizedString} */ ("Organizzatori")
	return /** @type {LocalizedString} */ ("Organizers")
});